import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';
import { Step, Stepper } from '@mui/material';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { useLocalization } from '@utils/useLocalization';
import { useTranslation } from 'react-i18next';

type IStep = {
  name: string;
};

export const StateStepper = ({
  steps,
  failed,
  activeStep,
  currentState,
  stateChanges,
}: {
  steps: IStep[];
  failed: boolean;
  activeStep: number;
  currentState: string;
  stateChanges: any;
}) => {
  const { sys } = useThemeTokens();
  const { localizedDateTime } = useLocalization();
  const { t } = useTranslation('transfer');
  const StepIcon = ({ index }: { index: number }) => {
    if (failed && index === activeStep) {
      return <CancelIcon sx={{ color: sys.color.negative }} />;
    }
    if (activeStep >= index) {
      return (
        <CheckIcon
          sx={{
            color:
              index + 1 === steps.length
                ? sys.color.positive
                : sys.color.primary,
          }}
        />
      );
    }
    return <CircleIcon sx={{ color: sys.color.background }} />;
  };

  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((state, index) => {
        const effectiveState =
          failed && activeStep === index ? currentState : state.name;
        return (
          <Step key={index}>
            <Box
              display='flex'
              flexDirection='column'
              alignItems='center'
              justifyContent='center'
            >
              <StepIcon index={index} />
              <Typography
                variant='bodyMedium'
                weight='bold'
                sx={{ mt: 1.5, mb: 0.5 }}
              >
                {t(`states.${effectiveState}`)}
              </Typography>
              {stateChanges.filter(
                (change: any) => change.to === effectiveState,
              ).length > 0 && (
                <Typography
                  variant='bodySmall'
                  colorVariant='variant'
                  sx={{ textAlign: 'center' }}
                >
                  {localizedDateTime(
                    stateChanges
                      .filter((change: any) => change.to === effectiveState)
                      .slice(-1)[0].createdAt,
                  )}
                </Typography>
              )}
            </Box>
          </Step>
        );
      })}
    </Stepper>
  );
};
